import React from "react";

const MAP = {
  draft: "bg-slate-100 text-slate-700 border-slate-200",
  awaiting_ekyc: "bg-amber-50 text-amber-800 border-amber-200",
  awaiting_documents: "bg-amber-50 text-amber-800 border-amber-200",
  submitted: "bg-blue-50 text-blue-800 border-blue-200",
  under_review: "bg-blue-50 text-blue-800 border-blue-200",
  more_info_requested: "bg-orange-50 text-orange-800 border-orange-200",
  recommended_for_approval: "bg-indigo-50 text-indigo-800 border-indigo-200",
  approved: "bg-emerald-50 text-emerald-800 border-emerald-200",
  rejected: "bg-red-50 text-red-800 border-red-200",
  cancelled: "bg-slate-100 text-slate-600 border-slate-200",
  disbursement_pending: "bg-violet-50 text-violet-800 border-violet-200",
  disbursed: "bg-emerald-50 text-emerald-800 border-emerald-200",
  active: "bg-emerald-50 text-emerald-800 border-emerald-200",
  completed: "bg-slate-100 text-slate-700 border-slate-200",
  defaulted: "bg-red-50 text-red-800 border-red-200",
  // doc statuses
  uploaded: "bg-slate-100 text-slate-700 border-slate-200",
  verified: "bg-emerald-50 text-emerald-800 border-emerald-200",
  needs_reupload: "bg-orange-50 text-orange-800 border-orange-200",
  // ekyc
  not_started: "bg-slate-100 text-slate-700 border-slate-200",
  pending: "bg-amber-50 text-amber-800 border-amber-200",
  failed: "bg-red-50 text-red-800 border-red-200",
};

export default function StatusBadge({ status }) {
  if (!status) return null;
  const cls = MAP[status] || "bg-slate-100 text-slate-700 border-slate-200";
  const label = String(status).replaceAll("_", " ");
  return (
    <span
      data-testid={`status-badge-${status}`}
      className={`inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-medium capitalize ${cls}`}
    >
      {label}
    </span>
  );
}
